var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.parames.screenMode == 'true')?_c('video-landscape',{attrs:{"detail":_vm.detail}}):_c('video-portraitscreen',{attrs:{"detail":_vm.detail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }